import { TFilter } from 'shared/types/filters';

export const FILTER_KEY: TFilter = 'suburbanArea';
